/*
/	Corentin BOUTON — Junior Mines Provence 2023
/	contact@junior-mines-provence.fr
/	https://junior-mines-provence.fr
*/

import { Stack, Row, Col, ToggleButton, Image, Card } from 'react-bootstrap';

import { Titre, Item } from '../Fonctions';

/// Orientation
import compas_img from "../../images/compass.webp";

function Orientation({ orientation, setOrientation, compas, setCompas }) {
	const debug = false;

	return (
		<Stack gap={2}>
		<Titre>Orientation</Titre>
			<Card style={{ width: '95%' }}>
				<Row>
					<ToggleButton
						style={{ width: 'min-content', margin: 'auto' }}
						className="mb-2"
						id="nord"
						type="checkbox"
						variant="outline-dark"
						checked={compas === 'nord'}
						onClick={(e) => {setOrientation(0); setCompas('nord')}}>
						<Item>Nord</Item>
					</ToggleButton>
				</Row>
				<Row style={{ marginLeft: '12%' }}>
					<Col style={{ margin: 'auto' }}>
						<ToggleButton
							style={{ width: 'min-content', margin: 'auto' }}
							className="mb-2"
							id="ouest"
							type="checkbox"
							variant="outline-dark"
							checked={compas === 'ouest'}
							onClick={(e) => {setOrientation(1); setCompas('ouest')}}>
						<Item>Ouest</Item>
						</ToggleButton>
					</Col>
					<Col style={{ margin: 'auto' }}>
						<Image src={compas_img} style={{ width: '50%', margin: 'auto' }}/>
					</Col>
					<Col style={{ margin: 'auto' }}>
						<ToggleButton
							style={{ width: 'min-content', margin: 'auto' }}
							className="mb-2"
							id="est"
							type="checkbox"
							variant="outline-dark"
							checked={compas === 'est'}
							onClick={(e) => {setOrientation(1); setCompas('est')}}>
						<Item>Est</Item>
						</ToggleButton>
					</Col>
				</Row>
				<Row>
					<ToggleButton
						style={{ width: 'min-content', margin: 'auto' }}
						className="mb-2"
						id="sud"
						type="checkbox"
						variant="outline-dark"
						checked={compas === 'sud'}
						onClick={(e) => {setOrientation(1); setCompas('sud')}}>
						<Item>Sud</Item>
					</ToggleButton>
				</Row>
			</Card>
			{debug ? orientation : null}
		</Stack>
	);
}

export default Orientation;
